import React, { useEffect, useRef } from "react";
import { OverlayTrigger, Row, Table, Tooltip } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faLink } from "@fortawesome/free-solid-svg-icons";
import { useParams } from "react-router-dom";
import ReactPlayer from "react-player";

import { info } from "./Data";
import colorSharp from "../assets/img/color-sharp.png";
import BackButton from "../helpers/BackButton";
import { ProjectCard } from "./ProjectCard";

const ProjectDescription = () => {
  const { id } = useParams();
  const descriptionRef = useRef(null);

  const tooltip = <Tooltip id="tooltip-visit-website">Visit website</Tooltip>;

  const project = info.projects.find((p) => p.title === id?.toUpperCase());

  const handleScrollToTop = () => {
    if (descriptionRef.current) {
      descriptionRef.current.scrollIntoView({
        behavior: "smooth",
        block: "start",
      });
    }
  };

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <section className="pj-des">
      <div className="container">
        <BackButton />

        <div className="row">
          <div className="col-12">
            <div className="pj-des-bx wow zoomIn px-2">
              <div
                ref={descriptionRef}
                className="d-flex justify-content-center mb-3"
              >
                <h2>{project.title} </h2>
                <OverlayTrigger placement="top" overlay={tooltip}>
                  <FontAwesomeIcon
                    icon={faLink}
                    style={{
                      fontSize: "16px",
                      padding: 6,
                      cursor: "pointer",
                    }}
                    onMouseEnter={(e) => (e.target.style.color = "#4691B8")}
                    onMouseLeave={(e) => (e.target.style.color = "white")}
                    onClick={() => window.open(project.url, "_blank")}
                  />
                </OverlayTrigger>
              </div>

              <div className="row d-flex justify-content-center">
                <ReactPlayer
                  url={project.video}
                  light={<img src={project.imgUrl} alt="Thumbnail" />}
                  controls
                  width="94%"
                  height="auto"
                  style={{ filter: "brightness(90%)" }}
                />
              </div>

              <div className="row d-flex justify-content-center mt-4 px-4 px-sm-5 text-start">
                <Table borderless>
                  <tbody>
                    <tr>
                      <td>
                        <p>Description:</p>
                      </td>
                      <td>
                        <p>{project.description}</p>
                      </td>
                    </tr>
                    <tr>
                      <td>
                        <p>URL:</p>
                      </td>
                      <td>
                        <a
                          href={project.url}
                          rel="noopener noreferrer"
                          target="_blank"
                        >
                          <p
                            style={{ cursor: "pointer" }}
                            onMouseEnter={(e) =>
                              (e.target.style.color = "#4691B8")
                            }
                            onMouseLeave={(e) =>
                              (e.target.style.color = "#b8b8b8")
                            }
                          >
                            {project.url}
                          </p>
                        </a>
                      </td>
                    </tr>
                    <tr>
                      <td>
                        <p>Sector:</p>
                      </td>
                      <td>
                        <p>{project.sector}</p>
                      </td>
                    </tr>
                    <tr>
                      <td>
                        <p>Timeline:</p>
                      </td>
                      <td>
                        <p>{project.timeline}</p>
                      </td>
                    </tr>
                    <tr>
                      <td>
                        <p>Work Type:</p>
                      </td>
                      <td>
                        <p>{project.workType}</p>
                      </td>
                    </tr>
                    <tr>
                      <td>
                        <p>Status:</p>
                      </td>
                      <td>
                        <p>{project.status}</p>
                      </td>
                    </tr>
                    <tr>
                      <td>
                        <p>TechStack:</p>
                      </td>
                      <td>
                        <div className="row row-cols-auto gap-2">
                          {project.topics.map((topic, index) => (
                            <div
                              className="col"
                              key={index}
                              style={{ border: "2px solid", borderRadius: 50 }}
                            >
                              <p>{topic}</p>
                            </div>
                          ))}
                        </div>
                      </td>
                    </tr>
                  </tbody>
                </Table>
              </div>
            </div>
            <h2 className="my-5 text-center">Other Projects</h2>
            <Row>
              {info.projects.map((project, index) => {
                return (
                  <ProjectCard
                    key={index}
                    {...project}
                    handleScrollToTop={handleScrollToTop}
                  />
                );
              })}
            </Row>

            <Row className="text-center mt-4">
              <small>Copyright 2022. All Rights Reserved</small>
            </Row>
          </div>
        </div>
      </div>
      <img className="background-image-left" src={colorSharp} alt="" />
    </section>
  );
};

export default ProjectDescription;
